export class Style {
    public static value: any = style;
}
